module.exports = __webpack_public_path__ + "/images/ico-primary-puzzle.7b6e2dc.svg";